'use client'
import { useState } from 'react'
import AirbnbRating from 'public/images/AirbnbRating.svg'
import Bathrooms from 'public/images/bathrooms.svg'
import Bedrooms from 'public/images/bedrooms.svg'
import Beds from 'public/images/beds.svg'
import BookingCom from 'public/images/BookingCom.svg'
import GoogleRating from 'public/images/GoogleRating.svg'
import Guests from 'public/images/guests.svg'
import HotelsRating from 'public/images/HotelsRating.svg'
import OverallRating from 'public/images/OverallRating.svg'
import AccuracyOfPhotos from 'public/images/ratings/AccuracyOfPhotos.svg'
import CheckInExperience from 'public/images/ratings/CheckInExperience.svg'
import SafetyAndSecurity from 'public/images/ratings/SafetyAndSecurity.svg'
import ValueForMoney from 'public/images/ratings/ValueForMoney.svg'

export const usePropertyDetails = (
  propertiesDetailsData,
  reviewsDataNewProps,
) => {

  const [showGuestsDropdown, setShowGuestsDropdown] = useState(false)
  const [showGuestsDropdownMobile, setShowGuestsDropdownMobile] =
    useState(false)

  const platformData = [
    {
      id: 'overall',
      icon: OverallRating,
      alt: 'OverallRating',
      label: 'Overall',
      rating: reviewsDataNewProps?.data?.overall_rating,
      hasSpecialLayout: true,
      hasBorder: true,
    },
    {
      id: 'google',
      icon: GoogleRating,
      alt: 'GoogleRating',
      label: 'Google',
      rating: reviewsDataNewProps?.data?.average_rating?.google,
    },
    {
      id: 'airbnb',
      icon: AirbnbRating,
      alt: 'AirbnbRating',
      label: 'Airbnb',
      rating: reviewsDataNewProps?.data?.average_rating?.airbnb,
    },
    {
      id: 'booking',
      icon: BookingCom,
      alt: 'BookingCom',
      label: 'Booking.com',
      rating: reviewsDataNewProps?.data?.average_rating?.booking_dot_com,
    },
    {
      id: 'hotels',
      icon: HotelsRating,
      alt: 'HotelsRating',
      label: 'Hotels.com',
      rating:
        Math.max(
          parseFloat(reviewsDataNewProps?.data?.average_rating?.vrbo) || 0,
          parseFloat(reviewsDataNewProps?.data?.average_rating?.revyoos) || 0,
          parseFloat(reviewsDataNewProps?.data?.average_rating?.tripadvisor) ||
            0,
        ) || 0.0,
    },
  ]

  const platformDataMobile = [
    {
      id: 'overall',
      icon: OverallRating,
      alt: 'OverallRating',
      label: 'Overall',
      rating: reviewsDataNewProps?.data?.overall_rating,
      hasSpecialLayout: true,
      hasBorder: true,
    },
    {
      id: 'google',
      icon: GoogleRating,
      alt: 'GoogleRating',
      label: 'Google',
      rating: reviewsDataNewProps?.data?.average_rating?.google,
    },
    {
      id: 'airbnb',
      icon: AirbnbRating,
      alt: 'AirbnbRating',
      label: 'Airbnb',
      rating: reviewsDataNewProps?.data?.average_rating?.airbnb,
    },
    {
      id: 'booking',
      icon: BookingCom,
      alt: 'BookingCom',
      label: 'Booking.com',
      rating: reviewsDataNewProps?.data?.average_rating?.booking_dot_com,
    },
    {
      id: 'hotels',
      icon: HotelsRating,
      alt: 'HotelsRating',
      label: 'Hotels.com',
      rating:
        Math.max(
          parseFloat(reviewsDataNewProps?.data?.average_rating?.vrbo) || 0,
          parseFloat(reviewsDataNewProps?.data?.average_rating?.revyoos) || 0,
          parseFloat(reviewsDataNewProps?.data?.average_rating?.tripadvisor) ||
            0,
        ) || 0.0,
    },
  ]

  // Add skeleton data for the platform cards
  const skeletonData = [
    {
      id: 1,
      iconSize: 24,
      labelWidth: 80,
      hasBorder: false,
      hasSpecialLayout: false,
    },
    {
      id: 2,
      iconSize: 24,
      labelWidth: 80,
      hasBorder: false,
      hasSpecialLayout: false,
    },
    {
      id: 3,
      iconSize: 24,
      labelWidth: 80,
      hasBorder: false,
      hasSpecialLayout: false,
    },
    {
      id: 4,
      iconSize: 24,
      labelWidth: 80,
      hasBorder: false,
      hasSpecialLayout: false,
    },
  ]

  const propertyDetails = [
    {
      id: 'guests',
      icon: Guests,
      value: propertiesDetailsData?.data?.max_guests || 0,
      label:
        (Number(propertiesDetailsData?.data?.max_guests) || 0) === 1
          ? 'guest'
          : 'guests',
      width: 90,
      imgWidth: 16,
      imgHeight: 16,
    },
    {
      id: 'bedrooms',
      icon: Bedrooms,
      value: propertiesDetailsData?.data?.bedrooms || 0,
      label:
        (Number(propertiesDetailsData?.data?.bedrooms) || 0) === 1
          ? 'bedroom'
          : 'bedrooms',
      width: 90,
      imgWidth: 20,
      imgHeight: 20,
    },
    {
      id: 'beds',
      icon: Beds,
      value: propertiesDetailsData?.data?.beds || 0,
      label:
        (Number(propertiesDetailsData?.data?.beds) || 0) === 1 ? 'bed' : 'beds',
      width: 90,
      imgWidth: 20,
      imgHeight: 20,
    },
    {
      id: 'bathrooms',
      icon: Bathrooms,
      value: propertiesDetailsData?.data?.bathrooms || 0,
      label:
        (Number(propertiesDetailsData?.data?.bathrooms) || 0) === 1
          ? 'bathroom'
          : 'bathrooms',
      width: 90,
      imgWidth: 16,
      imgHeight: 16,
    },
  ]

  const reviewCategories = [
    {
      key: 'VALUE',
      label: 'Value for Money',
      icon: ValueForMoney,
      width: 'w-[110px]',
    },
    {
      key: 'CHECKIN',
      label: 'Check-in Experience',
      icon: CheckInExperience,
      width: 'w-[150px]',
    },
    {
      key: 'CLEANLINESS',
      label: 'Safety & Security',
      icon: SafetyAndSecurity,
      width: 'w-[110px]',
    },
    {
      key: 'ACCURACY',
      label: 'Accuracy of Photos',
      icon: AccuracyOfPhotos,
      width: 'w-[180px]',
    },
  ]

  const reviewCategoriesMobile = [
    {
      key: 'VALUE',
      label: 'Value for Money',
      icon: ValueForMoney,
    },
    {
      key: 'CHECKIN',
      label: 'Check-in Experience',
      icon: CheckInExperience,
    },
    {
      key: 'CLEANLINESS',
      label: 'Safety & Security',
      icon: SafetyAndSecurity,
    },
    {
      key: 'ACCURACY',
      label: 'Accuracy of Photos',
      icon: AccuracyOfPhotos,
    },
  ]

  return {
    // UI state
    showGuestsDropdown,
    setShowGuestsDropdown,
    showGuestsDropdownMobile,
    setShowGuestsDropdownMobile,

    // Platform ratings
    platformData,
    platformDataMobile,
    skeletonData,

    // Property details
    propertyDetails,

    // Review categories
    reviewCategories,
    reviewCategoriesMobile,
  }
}
